// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// aliased
import Link from 'components/Link';

// local
import styles from './ResumeHeader.pcss';

const colbyWebsitePath = 'https://colby.dauphina.is';

export default class ResumeView extends PureComponent {
  
  static propTypes = {
    className: PropTypes.string,
  }
  static defaultProps = {}
  
  render() {
    const { className } = this.props;
    
    const classes = classnames(className, styles.resumeHeader);
    
    return (
      <div className={ classes }>
        <h1 className={ styles.name }>{ 'Colby Dauphinais' }</h1>
        <h1 className={ styles.title }>
          <span>{ 'Tech Leader, ' }</span>
          <span>{ 'Software Engineer, ' }</span>
          <span>{ 'Web Enthusiast' }</span>
          { /* <span>{ 'Full-stack JS Addict' }</span> */ }
        </h1>
        <div className={ styles.contact }>
          <Link
            className={ styles.link }
            children={ colbyWebsitePath }
            title={ 'visit my website' }
            to={ colbyWebsitePath } />
          <Link
            className={ styles.link }
            children={ 'colby@dauphina.is' }
            title={ 'email me' }
            to={ 'mailto:colby@dauphina.is' } />
        </div>
      </div>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/views/ResumeView/ResumeHeader/index.jsx